<div style="height: fit-content ; min-height: 850px; width: 100%;">

  <div class="d-flex justify-content-center " *ngIf="loading">
    <div class="spinner-border  " role="status" style="height: 100px; width: 100px; margin: 100px;">
      <span class="visually-hidden"></span>
    </div>
  </div>

  <div class="" *ngIf="!loading">

    <div class="card mt-4 ms-3 me-3">
      <div class="ps-4 pe-4 pt-1 pb-0 mt-2">
        <div class="d-flex  align-items-center" *ngIf="data?.subgroups?.length != 0">
          <div style="flex: 1"> {{ "subgroups" | translate  }}</div>
          <div class="divider ms-2"></div>
        </div>


        <div class="" *ngFor="let subgrupo of data?.subgroups; let i = index">
          <h2 class="">
            <button class="item  d-flex  align-items-center ms-2 me-2"
              type="button" data-bs-toggle="collapse"
              [attr.data-bs-target]="'#collapse' + i" aria-expanded="false" [attr.aria-controls]="'collapse' + i">
              <span style="width: 35%;" class="  d-flex  align-items-center ps-4 ">
                {{subgrupo?.name }}
              </span>


              <span style="width: 55%;" class="  d-flex  align-items-center">{{ subgrupo.description }}</span>
              <span style="width: 10%;" class=" d-flex  align-items-center">
                <button class="button-main-group text-primary" (click)="infoGroup(subgrupo)">
                  <i class="far fa-eye"></i>
                </button>
                <button class="button-main-group text-primary" (click)="viewGroup(subgrupo)">
                  <i class="far fa-chart-bar"></i>
                </button>

                <button class="button-main-group text-primary" (click)="detailGroup(subgrupo)">
                  <i class="fa fa-gear"></i>
                </button>
              </span>
            </button>
          </h2>
        </div>

      </div>

      <div class="ps-4 pe-3 mt-2">
        <div class="d-flex  align-items-center">
          <div style="flex: 1">{{"devices" | translate}}</div>
          <div class="divider ms-2"></div>
        </div>

        <div class="ps-4  pt-2 ">
          <table class="table table-striped ">
            <tbody>
              <tr *ngFor="let device of data?.devices; let x =index">
                <td>
                  <div class="row">
                    <span class="fw-semibold fs-6" style="cursor: pointer;" (click)="goToDevice(device.serial)">
                      {{device.name | uppercase}}
                    </span>
                    <span *ngIf="device.name == '' || device.name == null " class="fw-semibold fs-6" style="cursor: pointer;" (click)="goToDevice(device.serial)">
                      {{device.serial}}
                    </span>
                    <small  style="color: #006272;" >
                      <i class="fas fa-charging-station pe-1"></i>
                      {{device.serial}}
                    </small>
                  </div>

                </td>
                <!-- <td class="carga ms-0 p-0"  style="width: fit-content;"> -->
                <td>

                  <span *ngIf="device.role == 'all'"> <i class="far fa-edit"></i> </span>
                  <span *ngIf="device.role == 'owner'"> <i class="fas fa-user-shield"></i> </span>
                  <span *ngIf="device.role == 'write'"> <i class="fas fa-pen"></i> </span>
                  <span *ngIf="device.role == 'read'"> <i class="fas fa-book-open"></i> </span>
                </td>
                <!-- <td class="me-0  " style="width: fit-content;"> -->
                <td>

                  <span class="badge rounded-pill bg-info text-white f-4">
                    {{"lastCharge" | translate}}:
                  </span>
                </td>
                <!-- <td class="carga ms-0 "> -->
                <td>

                  <!-- {{"user"| translate}}: <span class="text-dark"> -->
                  <i class="fas fa-id-card"></i> <span class="text-dark">
                    {{ device?.historic?.[0]?.user ? device?.historic?.[0]?.user : '-' }}
                  </span>
                </td>
                <!-- <td class="carga ms-0 p-0"> -->
                <td>

                  <!-- {{"date"| translate}}: <span class="text-dark"> -->
                  <i class="fas fa-calendar"></i> <span class="text-dark">
                    {{ device?.historic?.[0]?.timestamp ?( device?.historic?.[0]?.timestamp | date: 'dd/MM/yy' ):
                    '--/--/--' }}
                  </span>
                </td>
                <!-- <td class="carga ms-0 p-0">{{"duration"|translate}}: -->
                <!-- <td class="carga ms-0 p-0"> -->
                <td>

                  <i class="fas fa-clock"></i>
                  <span class="text-dark">
                    {{ subtractDates( device?.historic?.[0]?.end_datetime, device?.historic?.[0]?.start_datetime ) }}
                  </span>
                </td>
                <td>
                  <i class="fas fa-bolt"></i>
                  <span class="text-dark">
                    {{ device?.historic?.[0]?.active ? device?.historic?.[0]?.active : 0}} Wh
                  </span>
                </td>
                <td>
                  <span class="carga ms-0 p-0">
                    {{"total"|translate}}:
                  </span>
                  <span class="p-2  text-end text-warning  fs-6"> {{ device?.total / 1000 }} kWh </span>
                </td>
                <td>
                  <button class="button-main-group" (click)="getHistoricGraph(device.serial)" data-bs-toggle="modal"
                  data-bs-target="#centeredModalSecondary"><i class="far fa-chart-bar"></i></button>
                  <button class="button-main-group" (click)="getHistoricsDevice(device.serial)" data-bs-toggle="modal"
                  data-bs-target="#centeredModalPrimary"><i class="fas fa-history"></i></button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

      <div class="d-flex   ">

        <div class="card w-50 ms-3 me-3">
          <div class="card-header text-center" >
            <h4 class="text-primary ">{{ "summaryConsumptions" | translate }} </h4>
          </div>

          <div class="card-body row m-2">
            <table class="table table-striped ">
              <tbody>
                <!-- <tr style="border-bottom-width: 2px; border-color: #00778B; "  > -->
                <tr *ngFor="let device of data?.devices; let x =index">
                  <td>
                    <span class="row">
                      <span *ngIf="device.name " class="ps-4 fs-5" > {{ device.name | uppercase }}    </span>
                      <span *ngIf="device.name == '' || device.name == null " class="ps-4 fs-5"  > {{ device.serial }}    </span>
                      <small class="ps-4" ><i class="fas fa-charging-station pe-1"></i> {{device.serial}} </small>
                    </span>
                  </td>
                  <td class=" text-end pe-4"> {{device.total/1000 | number}} kWh</td>
                </tr>
                <tr style="border-bottom-width: 2px; border-color: #00778B; "> </tr>
                <td class=" ps-5 fs-4"> {{"totalGroupConsumption" | translate }} {{ data?.name }} </td>
                <td class=" text-end pe-4">{{total / 1000 }} kWh</td>
              </tbody>
            </table>
          </div>
          <div class=" d-flex justify-content-center align-items-center mt-0 mb-3" style="width: 100%;" >
            <img src="assets/img/orbis/co2_3.png" alt="" srcset="" style="height: 75px;width: 90px;">
            <!-- <div class="ms-3 fs-4" style="color: #7FC823;" > {{total / 1000  * (0.33999986 ) | number:'1.3-5' }}  kgCo2  </div> -->
            <div class="ms-4 fs-4 text-success  " style="color: #7FC823;" > {{total / 1000  * (0.33999986 ) | number:'1.3-3' }}  kg CO<sub>2</sub> Saving </div></div>
        </div>

        <div class="card w-50 ms-3 me-3">
          <div class="card-header text-center" >
            <h4 class="text-primary">{{"lastRecharges"|translate}}</h4>
          </div>
          <div class="card-body row m-2">
              <table class="table table-striped ">
                <tbody>
                  <tr *ngFor="let charge of lastFiveCharges; let i = index">
                    <td>
                      <span class="row">
                        <span *ngIf="charge.name " class="ps-4 fs-5" > {{ charge.name | uppercase }}    </span>
                        <span *ngIf="charge.name == '' || charge.name == null " class="ps-4 fs-5" > {{ charge.serial }}    </span>
                        <small class="ps-4" ><i class="fas fa-charging-station pe-1"></i> {{charge.serial}} </small>
                      </span>
                    </td>
                    <!-- <td *ngIf="charge.name" class="ps-4">{{charge.name}}</td>
                    <td *ngIf="!charge.name || charge.name == '' "  class="ps-4">{{charge.serial}}</td> -->
                    <td class="ps-5"> {{ charge.user }} </td>
                    <td> {{ charge.timestamp | date: 'dd/MM/yy' }}</td>
                    <td class=" text-end pe-4"> {{ subtractDates( charge.end_datetime, charge.start_datetime ) }}</td>
                    <td class=" text-end pe-4"> {{charge.active }} Wh </td>
                  </tr>
                </tbody>
              </table>
          </div>
        </div>
      </div>
  </div>
</div>


  <!--  Modals -->

<div class="modal" id="centeredModalPrimary" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog-centered modal-card-devices m-auto" role="document">
    <div class="w-100 h-100">
      <div class="modal-header" style="background: transparent !important; border-bottom: none;">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="resetModals()"></button>
      </div>
      <div class="modal-content" [@zoomIn]="zoomIn" *ngIf="showModalHistorics">
        <app-card-historic [dataHistoric]="dataHistoric" [connectors]="connectors"></app-card-historic>
      </div>
    </div>
  </div>
</div>


<div class="modal" id="centeredModalSecondary" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog-centered modal-card-devices m-auto" role="document">
    <div class="w-100 h-100">
      <div class="modal-header" style="background: transparent !important; border-bottom: none;">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"   (click)="resetModals()"></button>
      </div>
      <div class="modal-content" [@zoomIn]="zoomIn" *ngIf="showModalGraphics">
        <app-card-analytics [dataAnalytics]="dataAnalytics" [connectors]="connectors" [serial]="device"  ></app-card-analytics>
      </div>
    </div>
  </div>
</div>

<div class="modal" id="centeredModalHistorics" tabindex="-1" role="dialog" aria-hidden="true" >
  <div class="modal-dialog-centered modal-card-devices m-auto" role="document">
    <div class="w-100 h-100 modal-content" >
      <div class="modal-header">
        <h2 class="modal-title">{{"historics" | translate}} </h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-6 d-flex justify-content-center">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" [(ngModel)]="selectAll"
                (change)="toggleAllDevices()" id="checkAll">
              <label class="form-check-label text-dark" for="checkAll"> {{"all" | translate  }} {{"devices"| translate }} </label>
              <div *ngFor="let device of selectedDevices; let i = index">
                <input class="form-check-input" type="checkbox" [(ngModel)]="device.check" id="check{{i}}">
                <label class="form-check-label" for="check{{i}}">
                  <span> {{ device.serial }}</span>
                </label>
              </div>
            </div>

          </div>
          <div class="col-6 d-flex justify-content-center align-items-center">
            <div class="row">

              <div class="form-check mb-2" >
                <input class="form-check-input" type="radio" [(ngModel)]="formato" name="fileFormat" value="csv"
                  id="csv">
                <label class="form-check-label" for="csv">
                  .csv
                </label>
              </div>
              <div class="form-check mt-2">
                <input class="form-check-input" type="radio" [(ngModel)]="formato" name="fileFormat" value="xls"
                  id="xls">
                <label class="form-check-label" for="xls">
                  .xls
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-primary " (click)="donwloadHistorics(selectedDevices, formato)" data-bs-dismiss="modal" aria-label="Close" >
          {{"download" | translate}}</button>
      </div>
    </div>
  </div>
</div>
